(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["reviews"] && !Shopify.designMode) return;
  try {
    
  const filterButtons = document.querySelectorAll('.rev-filter');
  const reviewCards = document.querySelectorAll('.rev-card');

  filterButtons.forEach((button) => {
    button.addEventListener('click', () => {
      const filter = button.dataset.cat;
      filterButtons.forEach((btn) => btn.classList.remove('active'));
      button.classList.add('active');
      reviewCards.forEach((card) => {
        if (filter === 'all' || card.dataset.cat === filter) {
          card.style.display = 'block';
        } else {
          card.style.display = 'none';
        }
      });
    });
  });

  } catch(e) { console.error(e); }
})();
})();
